import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import api_app = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;

type CsObject =
	| api_cs.Cnode
	| api_cs.Cstate_group__type__property
	| api_cs.Ccollection
	| api_cs.Ctext__type__property
	| api_cs.Cnumber__type__property
	| api_cs.Cfile__type__property;

export class Variable {
	constructor(public readonly parent: Variable | null, public readonly value: CsObject) {}
}

export function ancestor_variable_path(root: api_app.Cancestor_variable_path, variable: Variable): Variable {
	return root.properties.has_steps.switch({
		no: variable,
		yes: ($) => ancestor_variable_path($.properties.tail, variable.parent!),
	});
}

export function ancestor_named_object_path(root: api_app.Cancestor_named_object_path, variable: Variable): Variable {
	switch (root.properties.has_steps.state.name) {
		case "no":
			return variable;
		case "yes": {
			const $ = root.properties.has_steps.state.node;
			if (!variable.parent) throw new Error("Unexpected undefined variable parent");
			return ancestor_named_object_path($.properties.tail, variable.parent);
		}
		default:
			unexpectedState(root.properties.has_steps.state);
	}
}

export function variable_assignment(
	root: api_app.Cvariable_assignment | api_app.Cnamed_object_assignment,
	parent: Variable | null,
	value: CsObject
): Variable {
	switch (root.properties.name.state.name) {
		case "implicit":
			return new Variable(parent, value);
		case "explicit":
			return new Variable(parent, value);
		default:
			unexpectedState(root.properties.name.state);
	}
}

export function optional_variable_assignment(
	root: api_app.Coptional_variable_assignment | api_app.Coptional_named_object_assignment,
	parent: Variable | null,
	value: CsObject
): Variable | null {
	switch (root.properties.has_assignment.state.name) {
		case "no":
			return parent;
		case "yes": {
			const $ = root.properties.has_assignment.state.node;
			return variable_assignment($.properties.assignment, parent, value);
		}
		default:
			unexpectedState(root.properties.has_assignment.state);
	}
}
